export default "__VITE_ASSET__952113aa__"